import { useCallback } from 'react';

import { useAnalyticsEvents as useAnalyticsNextEvents } from '@atlaskit/analytics-next';

import { EVENT_CHANNEL } from './constants';
import { type EventKey } from './generated/analytics.types';
import createEventPayload from './generated/create-event-payload';

export const useAnalyticsEventsWithTags = () => {
	const { createAnalyticsEvent } = useAnalyticsNextEvents();

	const fireEventWithTags = useCallback(
		<K extends EventKey>(tags: string[], ...params: Parameters<typeof createEventPayload<K>>) => {
			const event = createAnalyticsEvent(createEventPayload<K>(...params));
			if (event.payload) {
				event.payload.tags = tags;
			}
			event.fire(EVENT_CHANNEL);
		},
		[createAnalyticsEvent],
	);

	return {
		fireEventWithTags,
	};
};
